import React from "react"
import SmiWidget from "../SmiWidget"

export function Push({isDesktop, isFull}) {
    return (
        <SmiWidget blockId={isFull ? (isDesktop ? '30233' : '30235') : (isDesktop ? '30232' : '30234')}/>
    )
}
